/** @format */

import React, { FC, ReactNode } from 'react';
import { Dropdown as AntDDropwdown } from 'antd';
import { placementType } from 'infrastructure/interfaces/button.types';

type Props = {
  menu: any;
  placement?: placementType;
  children?: ReactNode;
  className?: string;
  style?: any;
  onClick?: (record: any) => void;
};

const Dropdown: FC<Props> = ({
  menu,
  placement,
  children,
  className,
  style,
  onClick,
}): JSX.Element => {
  return (
    <AntDDropwdown
      trigger={['click']}
      className={className}
      menu={menu}
      placement={placement}
      overlayStyle={style}
      onOpenChange={onClick}
    >
      {children}
    </AntDDropwdown>
  );
};

Dropdown.defaultProps = {
  placement: 'bottom',
};

export default Dropdown;
